import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { readReturnTo, withReturnTo } from "@/lib/returnTo";

/**
 * `/signup` and `/onboarding`, kept as addresses (2026-10-28).
 *
 * Both used to be screens — a role-less sign-up form, then a "client or
 * FixyBee?" step — and both are linked from emails, ads and printed flyers
 * that cannot be recalled. `?role=provider` was the hint those links carried,
 * so it still picks the FixyBee door; everything else is a client's. The
 * destination rides on.
 */
export default function SignupRedirect() {
  const [searchParams] = useSearchParams();
  const door = searchParams.get("role") === "provider" ? "/signup/provider" : "/signup/client";
  return <Navigate to={withReturnTo(door, readReturnTo(searchParams))} replace />;
}
